import React from 'react';
import { FormControl, TextField } from '@material-ui/core';
import classNames from 'clsx';

import { EurobandCarRegistrationNumberControlProps } from './EurobandCarRegistrationNumberControl.interfaces';
import { UtilService } from 'app/services/util.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { useCarRegistrationNumberControl } from 'app/shared/hooks/controls/useCarRegistrationNumberControl';
import { useStyles } from './EurobandCarRegistrationNumberControl.styles';

export default function EurobandCarRegistrationNumberControl(
  props: EurobandCarRegistrationNumberControlProps
) {
  const {
    input,
    input: { value: inputValue },
    meta,
    meta: { touched, valid },
    large,
    label,
    tooltip,
    tooltipIcon,
    subLabel,
    helperText,
    disabled,
    width,
    isQuestionValid,
    placeholder,
    eurobandClass,
    withoutDoneAdornment,
  } = props;

  const {
    focused,
    handleBlur,
    handleChange,
    handleClick,
    onFocus,
    maxLength,
  } = useCarRegistrationNumberControl(props);

  const classes = useStyles({ large, focused })();

  return (
    <ControlContainer
      inputId={input.name}
      tooltip={tooltip}
      tooltipIcon={tooltipIcon}
      subLabel={subLabel}
      helperText={helperText}
      isQuestionValid={isQuestionValid}
      meta={meta}
      floating
      floated={focused || UtilService.hasValue(inputValue)}
      focused={focused}
      width={width}
    >
      <FormControl fullWidth>
        <TextField
          {...input}
          id={input.name}
          disabled={disabled}
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={handleClick}
          onFocus={onFocus}
          label={label}
          classes={{
            root: classes.textField,
          }}
          InputProps={{
            startAdornment: (
              <>
                <div
                  className={classNames(classes.euroband, eurobandClass, {
                    [classes.eurobandDisabled]: disabled,
                    [classes.eurobandFocused]: focused,
                  })}
                />
                {valid &&
                  !focused &&
                  UtilService.hasValue(inputValue) &&
                  !withoutDoneAdornment && (
                    <DoneAdornment className={classes.doneAdornment} />
                  )}
              </>
            ),
            classes: {
              adornedStart: classes.adornedStart,
              input: classes.input,
            },
          }}
          inputProps={{
            maxLength,
          }}
          error={touched && !valid}
          variant={'outlined'}
          margin={'dense'}
          placeholder={placeholder}
          InputLabelProps={{
            shrink: UtilService.hasValue(inputValue) || focused,
            classes: {
              root: classes.inputLabel,
              shrink: `shrink`,
            },
          }}
        />
      </FormControl>
    </ControlContainer>
  );
}
